import React from 'react'

// import AlumniMeet from '../components/alumni/alumniMeet'
import Recruiters from '../components/placement/recruiters'
import AlumniHighlight from '../components/alumni/alumniHighlight'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'


const PlacementPage = () => {
    return (
        <>
            <Navbar />
            <Recruiters />
            <AlumniHighlight />
            <Footer />

        </>
    )
}

export default PlacementPage